import { createSlice } from '@reduxjs/toolkit'

// Setup the initial state

const initialState = {
  consultAddresses: {},
  consultAddressesDetailed: {},
  insertAddress: {},
  insertEmailAddress: {},
  updateAddress: {},
};

export const addressesSlice = createSlice({
  name: 'addresses',
  initialState,
  reducers: {

    // Consult Addresses

    setConsultAddressesLoading: (state) => {
      state.consultAddresses = {
        isLoading: true,
      };
    },

    setConsultAddressesSuccess: (state, action) => {
      state.consultAddresses = {
        data: action.payload
      };
    },

    setConsultAddressesFailure: (state, action) => {
      state.consultAddresses = {
        error: action.payload,
      }
    },

    
    // Consult Addresses Detailed

    setConsultAddressesDetailedLoading: (state) => {
      state.consultAddressesDetailed = {
        isLoading: true,
      };
    },

    setConsultAddressesDetailedSuccess: (state, action) => {
      state.consultAddressesDetailed = {
        data: action.payload
      };
    },

    setConsultAddressesDetailedFailure: (state, action) => {
      state.consultAddressesDetailed = {
        error: action.payload,
      }
    },



    // Insert Address

    setInsertAddressLoading: (state) => {
      state.insertAddress = {
        isLoading: true,
      };
    },

    setInsertAddressSuccess: (state, action) => {
      state.insertAddress = {
        data: action.payload,
        success: true
      };
    },

    setInsertAddressFailure: (state, action) => {
      state.insertAddress = {
        error: action.payload,
      }
    },

    clearInsertAddress: (state) => {
      state.insertAddress = {}
    },


    // Insert Email Address

    setInsertEmailAddressLoading: (state) => {
      state.insertEmailAddress = {
        isLoading: true,
      };
    },

    setInsertEmailAddressSuccess: (state) => {
      state.insertEmailAddress = {
        success: true
      };
    },

    setInsertEmailAddressFailure: (state, action) => {
      state.insertEmailAddress = {
        error: action.payload,
      }
    },

    clearInsertEmailAddress: (state) => {
      state.insertEmailAddress = {}
    },

    // Update Address

    setUpdateAddressLoading: (state) => {
      state.updateAddress = {
        isLoading: true,
      };
    },

    setUpdateAddressSuccess: (state, action) => {
      state.updateAddress = {
        data: action.payload
      };
    },

    setUpdateAddressFailure: (state, action) => {
      state.updateAddress = {
        error: action.payload,
      }
    },

    clearUpdateAddress: (state) => {
      state.updateAddress = {}
    },

  },
})

export const {
  setConsultAddressesLoading, setConsultAddressesSuccess, setConsultAddressesFailure,
  setConsultAddressesDetailedLoading, setConsultAddressesDetailedSuccess, setConsultAddressesDetailedFailure,
  setInsertAddressLoading, setInsertAddressSuccess, setInsertAddressFailure, clearInsertAddress,
  setInsertEmailAddressLoading, setInsertEmailAddressSuccess, setInsertEmailAddressFailure, clearInsertEmailAddress,
  setUpdateAddressLoading, setUpdateAddressSuccess, setUpdateAddressFailure, clearUpdateAddress,
} = addressesSlice.actions

export default addressesSlice.reducer;